/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';
import DialogView from 'apmui/components/dialog/View';
import PageType from 'apmui/page/PageType';
import ITemplateModel from './Model';
import PageHeader from './PageHeader';
import PageFooter from './PageFooter';

/**
 * Generate CSS classes list for the page.
 */
function classList(page: string): string {
    // Memoize results
    if (!classList.cache.hasOwnProperty(page)) {
        let classes = 'apmui-root ';
        /* Add common style for all policy pages */
        if (page !== PageType.WEBTOP) {
            classes += 'apmui-page-policy ';
        }

        classes +=
            'apmui-page-' +
            // use dashes instead of camelCase
            page.replace(/[A-Z]/g, (char) => '-' + char.toLowerCase());
        classList.cache[page] = classes;
    }
    return classList.cache[page];
}
classList.cache = {};

/**
 * General UI implementation
 */
class PageView extends React.Component<ITemplateModel> {
    render() {
        const showDialog = this.props.dialogs && this.props.dialogs.length > 0;
        return (
            <div className={classList(this.props.pageType)} aria-hidden={showDialog}>
                {showDialog && <DialogView {...this.props.dialogs[0]} />}
                <PageHeader {...this.props.general} />
                <main className="apmui-main">{this.props.children}</main>
                <PageFooter {...this.props.general} />
            </div>
        );
    }
}
export default PageView;
